<template>
  <div>
    <b-button-toolbar class="actions">
        <b-button-group size="sm">
          <b-btn v-b-modal.dashboard v-b-tooltip.hover title="Aggiungi in dashboard" class="btn-action">
            <img src="/static/icons/icon-19.png" class="Salva in dashboard" >
          </b-btn>
          <b-btn v-b-modal.save v-b-tooltip.hover title="Salva grafico" class="btn-action">
            <img src="/static/icons/icon-18.png" class="Salva grafico" >
          </b-btn>
          <b-btn @click="exportImage()" v-b-tooltip.hover title="Esporta come immagine" class="btn-action">
            <img src="/static/icons/icon-17.png" class="Esporta" >
          </b-btn>
          <!-- <b-btn v-b-modal.excel v-b-tooltip.hover title="Esporta in dati in Excel">
            <font-awesome-icon icon="file-excel" />
          </b-btn> -->
        </b-button-group>
    </b-button-toolbar>

    <b-modal id="save" title="Salva grafico" @ok="save('menu')" ok-title="Salva" cancel-title="Annulla">
      <b-form-group label="Nome del grafico">
        <b-form-input v-model.trim="name"></b-form-input>
      </b-form-group>
      <b-form-checkbox v-model="keepDates" :value="true" :unchecked-value="false">Mantieni date selezionate</b-form-checkbox>
    </b-modal>

    <b-modal id="dashboard" title="Aggiungi grafico in dashboard" @ok="save('dashboard')" ok-title="Salva" cancel-title="Annulla">
      <b-form-group label="Nome del grafico">
        <b-form-input v-model.trim="name"></b-form-input>
      </b-form-group>
      <b-form-checkbox v-model="keepDates" :value="true" :unchecked-value="false"> Mantieni date selezionate</b-form-checkbox>
    </b-modal>

    <b-modal class="download-modal" ref="download" title="Download immagine" :hide-footer="true">
      <div>
        <b-img fluid :src="imageSrc" />
      </div>
      <div class="text-center mt-4">
        <b-btn variant="success" :href="imageUri" type="a" download="grafico.png">Download</b-btn>
      </div>
    </b-modal>

    <b-modal title="Download Excel" id="excel">
      <form action="/api/v1/data/download" method="post">
        <b-btn type="submit">Download</b-btn>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Actions",
  props: ['filter', 'chartType'],

  data() {
    return {
      name: null,
      imageUri: null,
      imageSrc: null,
      chartName: null,
      keepDates: true
    }
  },

  computed: {

  },

  methods: {
    save(where) {
      this.$store.commit("loading")
      let data = _.clone(this.filter)
      data.name = this.name
      data.chartType = this.chartType
      data.dashboard = where == "dashboard"
      data.keepDates = this.keepDates
      this.$store.dispatch("charts/saveChart", data).then( response => {
        this.$store.commit("stopLoading")
        this.$store.dispatch("loadUser")
        this.$notify({
          type: "success",
          text: "Grafico salvato",
          title: 'Successo'
        }); 
        // this.$toasted.show('Grafico salvato', { duration: 3000, theme: "bubble" })
      })
    },
    remove() {

    },
    exportImage() {
      this.$store.commit("loading")
      html2canvas(document.querySelector("#chart")).then(canvas => {
        this.$store.commit("stopLoading")
          this.imageSrc = canvas.toDataURL("image/png")
          this.imageUri = this.imageSrc.replace("image/png", "image/octet-stream");
          this.$refs.download.show()
      });
    }
  }
}
</script>

<style scoped>
.actions button {
  width: 30px;
}
.btn-action {
  background: #fff !important;
  color: #333 !important;
  border: 0;
  opacity: 1;
}
.btn-action:hover {
  background: #fff !important;
  color:#333 !important;
  opacity: .8;
}
.btn-action img {
  width: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Actions.vue